// src/lib/formatGuildName.ts
// Falls back to the guild ID when the name is missing — deliberately
// checks for empty string, not just null/undefined. The backend's own
// write path (bot/index.js) uses `interaction.guild?.name || ''`, so
// an empty string is a real possible value here, not a theoretical
// one — a plain `name ?? id` fallback (used in several places before
// this, found 2026-07-14) silently does nothing for that case, since
// `??` only catches null/undefined.
export function formatGuildName(name: string | null | undefined, id: string): string {
  return name && name.trim() !== '' ? name : id;
}
